import { call, put, takeEvery } from 'redux-saga/effects'

import { RealtimeClient, request } from '../../utils'

// Transitional. Moved here verbatim from the deleted CommentsFeature because it
// is the audience build's only realtime source — polls and handouts invalidate
// off the action it dispatches, not just questions. It is a second Faye client
// alongside src/realtime/realtime.ts (which chat and questions use), and it
// stays only until audience poll/handout realtime moves off redux. Consolidating
// first requires confirming that the v1 `realtime_channel` and realtimeInfo's
// `publicChannelId` resolve to the same channel for an audience token.

// `/api/comment/list` is still on API v1, which only returns JSON when asked.
const getLiveRealtimeData = (liveId) =>
  request({
    url: '/api/comment/list',
    method: 'GET',
    data: {
      object_id: liveId,
      include_realtime_p: 1,
      size: 0,
      format: 'json',
      raw: '1',
    },
  })

let realtimeClient

function* subscribeToRealtimeUpdates(config, actionName) {
  const { realtime_url: realtimeUrl, realtime_channel: realtimeChannel } =
    config

  yield call(realtimeClient.connect, realtimeUrl)

  const sagaChannel = yield call(
    realtimeClient.subscribeThroughSagaChannel,
    `${realtimeChannel}/all_json`
  )

  yield takeEvery(sagaChannel, function* onRealtimeUpdate(realtimeData) {
    yield put({ type: actionName, realtimeData })
  })
}

function* fetchRealtimeWorker(actionName, liveId) {
  const config = yield call(getLiveRealtimeData, liveId)

  yield call(subscribeToRealtimeUpdates, config, actionName)
}

function* enableAudienceRealtime(actionName, liveId) {
  if (realtimeClient) {
    return
  }

  realtimeClient = new RealtimeClient()
  yield call(fetchRealtimeWorker, actionName, liveId)
}

export { enableAudienceRealtime }
